import styled from 'styled-components/macro';

export const Input = styled.input`
  background-image: ${(props) => (props.icon ? `url(${props.icon})` : 'none')};
  text-indent: ${(props) => (props.icon ? '40px' : '0')};
  background-repeat: no-repeat;
  background-position-y: 16px;
  background-position-x: 2px;

  padding: 10px 0 5px;
  min-width: 320px;
  width: 100%;
  font-size: 18px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid #ababab;
`;
